export const transactionTypes = Object.freeze({
  FUND_WALLET: "fund_wallet",
  WALLET_TRANSFER: "wallet_transfer",
  RESERVATION_HOLD: "reservation_hold",
  RESERVATION_RELEASE: "reservation_release",
  REVERSAL: "reversal",
  CLAIMS: "claims",
  OTHERS: "others",
});
